import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

// IMPORTANT: import the actual file
import nccLogo from '../assets/SecondaryLogo/PNG/NCC_SecondaryLogo-green.png';

function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => setIsNavOpen((prev) => !prev);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img
            src={nccLogo}
            alt="Site Logo"
            className="logo-img"
          />
        </div>

        <button
          className={`nav-toggle ${isNavOpen ? 'nav-open' : ''}`}
          onClick={toggleNav}
          aria-label="Toggle navigation menu"
        >
          <span className="hamburger"></span>
        </button>

        <nav className={`nav-links ${isNavOpen ? 'show-menu' : ''}`}>
          <ul>
            <li>
              <Link to="/" onClick={() => setIsNavOpen(false)}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={() => setIsNavOpen(false)}>
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={() => setIsNavOpen(false)}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/gallery" onClick={() => setIsNavOpen(false)}>
                Gallery
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
